import {Button, IconButton, Typography} from "@mui/material";
import PhoneNumberAuthenticatorComponent from "../components/PhoneNumberAuthenticatorComponent";
import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import EnterCodeAuthenticatorComponent from "../components/EnterCodeAuthenticatorComponent";
import {useTranslation} from "i18nano";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {CheckNeedAdditionalAuth} from "../helpers/authHelper";
import {useAuthStore} from "../stores/authStore";
import {useNotification} from "../stores/notificationStore";
import {useUserStore} from "../stores/userStore";
import {ApiService} from "../api/ApiService";
import {LoginResponse, LoginResponseTwoFactor} from "../api/types/LoginResponse";
import {ApiFailure, ApiSuccess} from "../api/types/ApiResponse";
import StackCard from "../components/StackCard";
import WithLogoAndSelectLanguageWrapper from "../components/WithLogoAndSelectLanguageWrapper";

const PhoneNumberPage = () => {
    const authStore = useAuthStore();
    const userStore = useUserStore();
    const notification = useNotification();
    const navigate = useNavigate();
    const t = useTranslation();

    const [errors, setErrors] = useState<string[]>([]);
    const [step, setStep] = useState(0);
    const [loading, setLoading] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState("")
    const [counter, setCounter] = useState(0);

    useEffect(() => {
        if (!authStore.login || !authStore.password) {
            navigate("/login")
        }
    }, [])
    useEffect(() => {
        counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    }, [counter]);

    const getSms = async (phoneNumber: any) => {
        setPhoneNumber(phoneNumber);
        setLoading(true);
        if (!authStore.login || !authStore.password) return;
        const response = await ApiService.GetActivationSms(authStore.login, authStore.password, phoneNumber);
        if (response.success) {
            setStep(1);
            setCounter(60);
            localStorage.setItem("lastSendSms", new Date().getTime().toString())
        } else {
            setErrors([response.errors[0]]);
        }
        setLoading(false);
    }
    const confirmPhoneNumber = async (code: any) => {
        setLoading(true);
        if (!authStore.login || !authStore.password) return;
        const response = await ApiService.PhoneConfirm(authStore.login, authStore.password, phoneNumber, code);
        CheckResponse(response);
        setLoading(false);
    }
    const skipPhone = async () => {
        setLoading(true);
        if (!authStore.login || !authStore.password) return;
        const response = await ApiService.PhoneSkip(authStore.login, authStore.password);
        CheckResponse(response);
        setLoading(false);
    }

    const CheckResponse = (response: ApiSuccess<LoginResponse> | ApiFailure<LoginResponseTwoFactor | null>) => {
        if (response.success) {
            userStore.login(response.data);
        } else {
            const needText = CheckNeedAdditionalAuth(response);
            if (needText) {
                navigate(needText);
                return;
            }
            if (response.errors[0]) {
                notification.open(response.errors[0], "error");
            } else {
                notification.open(t("Something went wrong"), "error");
            }
            setStep(1);
        }
    }

    return (
            <WithLogoAndSelectLanguageWrapper>
                <StackCard>
                    {step !== 0 ?
                            < IconButton aria-label="back" style={{position: "absolute", left: "5px", top: "5px"}}
                                         onClick={() => setStep(step - 1)}>
                                <ArrowBackIcon/>
                            </IconButton>
                            : null
                    }
                    {step === 0 ?
                            <PhoneNumberAuthenticatorComponent errors={errors} loading={loading} onClick={getSms}
                                                               onClickSkip={skipPhone}/>
                            :
                            step === 1 ?
                                    <>
                                        <EnterCodeAuthenticatorComponent
                                                onClick={confirmPhoneNumber} loading={loading}
                                                title={t("Enter Code")}
                                                description={
                                                    <span>{t("We have sent a verification code to your phone number")}</span>}
                                        />
                                        <div style={{display: 'flex', justifyContent: "center"}}>
                                            {counter > 0 ?
                                                    <Typography style={{marginTop: 10}} variant="body2"
                                                                display="block" gutterBottom>
                                                        {t("You can send code again after seconds", {seconds: `${counter}`})}
                                                    </Typography>
                                                    :
                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        width: "100%"
                                                    }}>
                                                        <Button style={{marginTop: 10}} variant="outlined"
                                                                size={"large"}
                                                                onClick={skipPhone}
                                                                fullWidth>{t("Skip")}</Button>
                                                        <Button style={{marginTop: 10}} variant="text"
                                                                size={"small"}
                                                                onClick={() => getSms(phoneNumber)}>{t("Send code again")}</Button>
                                                    </div>
                                            }
                                        </div>
                                    </>
                                    : null
                    }
                </StackCard>
            </WithLogoAndSelectLanguageWrapper>
    )
}

export default PhoneNumberPage